<template>
    <div class="btn btn-link"
        @click="toggleToWishlist">
        <i :class="{'fa-solid': this.wishlist.find((product) => product.id == this.dataProduct.id)}"
            class="fa-regular fa-heart"></i>
    </div>
</template>
<script>
export default {
    props: ['dataProduct'],
    data() {
        return {
            t: t,
            wishlist: wishlist
        }
    },
    methods: {
        toggleToWishlist() {
            axios
            .post("/ajax/wishlist/toggleToWishlist", {
                id: this.dataProduct.id
            })
            .catch((error) => { Vue.notify({text: error.message, type: 'error'})  })
            .then((response) => {
                Vue.notify({text: response.data.message.text, type: response.data.message.type})
                this.wishlist = response.data.wishlist
                this.$root.$emit("updateWishlist", response.data.wishlist);
            });
        },
    },
}
</script>
